import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { SocieteLinkedService } from './societe-linked.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SiteModel } from 'src/app/shared/models/societe-linked/site.model';
import { APICONSTANTS } from '../../constants/api-constants';
import { HostnameService } from '../basic/hostname.service';

@Injectable()
export class SiteService extends SocieteLinkedService<SiteModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTESITE, hostnameService);
  }

}
